import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1202c8cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex", "type", "disabled"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "loader logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    tabindex: $props.tabIndex,
    type: $props.type,
    disabled: $props.disabled || $props.isLoading,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.clicked()), ["stop","prevent"])),
    class: _normalizeClass({
      loading: $props.isLoading,
      'has-icon': !!$props.iconSvg,
      primary: $props.color === 'primary',
      secondary: $props.color === 'secondary',
    })
  }, [
    ($props.iconSvg && !$props.isLoading)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "icon",
          innerHTML: $props.iconSvg
        }, null, 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    ($props.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createVNode($setup["LoadingGif"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", null, _toDisplayString($props.text), 1 /* TEXT */)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}